import Typography from '@mui/material/Typography';
import type { FilterCriteria, RangeWithRadioConfigurableFilter } from '../../types.ts';
import { getSelectedOption, getSelectedRangeOptions } from '../../utils/typeGuards.ts';
import { RadioSelector } from './RadioSelector.tsx';
import { RangeSelector } from './RangeSelector.tsx';

export type RangeWithRadioFilterProps<Criteria extends FilterCriteria> = {
  appliedFilters?: FilterCriteria;
  onOptionsChange: (key: string, options: string | [string | undefined, string | undefined] | undefined) => void;
  config: RangeWithRadioConfigurableFilter<Criteria>['config'];
};

export const RangeWithRadioFilter = <Criteria extends FilterCriteria>({
  appliedFilters,
  onOptionsChange,
  config,
}: RangeWithRadioFilterProps<Criteria>) => {
  const { rangeFilterKey, radioFilterKey, availableOptions, rangeLabel, radioLabel } = config;

  return (
    <>
      {radioLabel && (
        <Typography
          variant="body1Bold"
          sx={{
            display: 'block',
            mb: 2,
            marginBottom: theme => theme.spacing(1.5),
          }}
        >
          {radioLabel}
        </Typography>
      )}

      <RadioSelector
        options={availableOptions}
        selectedOptions={getSelectedOption(appliedFilters?.[radioFilterKey])}
        onOptionChange={value => onOptionsChange(radioFilterKey, value)}
        orientation="row"
        defaultOption="Any"
      />

      {rangeLabel && (
        <Typography
          variant="body1Bold"
          sx={{
            display: 'block',
            mb: 2,
            marginBottom: theme => theme.spacing(1.5),
          }}
        >
          {rangeLabel}
        </Typography>
      )}

      <RangeSelector
        filterKey={rangeFilterKey}
        selectedOptions={getSelectedRangeOptions(appliedFilters?.[rangeFilterKey])}
        onOptionChange={value => onOptionsChange(rangeFilterKey, value)}
        config={config}
      />
    </>
  );
};
